import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'currency'})
export class CurrencyPipe implements PipeTransform {
	transform(value: number): string {
		if (value == undefined || value == null) {
			return "Invalid Currency";
		}

		if (isNaN(value)) {
			return "Currency is not a number";
		}

		// Create our number formatter.
		var formatter = new Intl.NumberFormat('en-ZA', {
			style: 'currency',
			currency: 'ZAR'
		});

		return formatter.format(value);
	}
}



// WEBPACK FOOTER //
// ./src/app/pipes/currency.pipe.ts